// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__3pY_r","selected":"Chip_selected__2w3Ua"};